<app-signal-issue-form (signal)="onSignalIssue($event)"
                       [isLoading]="isLoading"></app-signal-issue-form>
<app-confirmation-modal #errorModal
                        title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage"
                        [confirmOnlyMode]="true"
                        [showConfirmButton]="false ">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.signalIssue.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.signalIssue.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>


